<template>
	<div class="auth-layout tw-min-h-screen tw-bg-d9d tw-w-full tw-relative">
		<div class="auth-layout__gradient tw-absolute tw-inset-x-0 tw-bg-gradient-to-tr tw-from-green-379 tw-to-green-1A5 tw-transform tw-left-1/2 tw--translate-x-1/2 tw--rotate-4 tw-z-10">
			<div class="tw-h-28 tw-absolute tw-inset-x-0 tw-transform tw-rotate--4 tw-bottom-0 tw-bg-white tw-opacity-20"></div>
		</div>
		<div class="tw-max-w-xl tw-mx-auto tw-relative tw-z-50">
			<img
				alt="Brand Logo Text"
				class="tw-mx-auto tw-w-96 tw-mt-8"
				src="@/assets/img/logo-test-white.png"
			>

			<b-card class="tw-mt-12 ">
				<img
					alt="Brand Logo"
					class="tw-mx-auto tw--mt-4 tw-w-72"
					src="@/assets/img/logo-building.png"
				>
				<h1 class="tw-text-center tw-font-light tw-text-4xl tw-text-b3b tw--mt-4">BIENVENIDO!</h1>
				<p class="tw-text-2xl tw-font-light tw-text-b3b tw-text-center tw-my-5">Por favor ingresa tus datos</p>

				<router-view></router-view>
			</b-card>
			<div class="tw-mb-24 tw-mt-2">
				<router-link
					v-if="$route.path==='/login'"
					to="/forgot-password"
					class="tw-text-green-3fa tw-font-medium tw-text-lg"
				>Olvidaste tu contrasena?</router-link>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'AuthLayout'
}
</script>

<style lang='scss'>
	.auth-layout {
		overflow-x: hidden;
		&__gradient {
			top: -68px;
			width: 105%;
			min-height: 827px;
		}
	}
</style>